import Seo from '@/components/public/Seo';
import MemberCard from '@/components/public/cards/MemberCard';
import PageHero from '@/components/public/sections/PageHero';
import Container from '@/components/public/ui/Container';
import { useSite } from '@/hooks/useSite';
import type { BodyMemberView } from '@/types';

type Props = { members: BodyMemberView[] };

export default function ExecutiveBody({ members }: Props) {
  const mandate = useSite().mandate;
  const [president, ...officers] = members;

  return (
    <>
      <Seo title="Junta de Freguesia" description="O órgão executivo da freguesia." />
      <PageHero badge="Órgãos autárquicos" title="Junta de Freguesia" />
      <Container className="space-y-12 py-12">
        {members.length > 0 ? (
          <p className="text-on-surface-light mx-auto max-w-3xl text-center leading-relaxed">
            Conheça os eleitos que compõem o órgão executivo da freguesia
            {mandate ? ` para o mandato ${mandate}` : ''}.
          </p>
        ) : (
          <p className="text-on-surface-light text-center">
            A composição do órgão executivo estará disponível em breve.
          </p>
        )}

        {president && (
          <section>
            <div className="flex justify-center">
              <MemberCard
                variant="featured"
                initials={president.initials}
                name={president.name ?? ''}
                role={president.role ?? ''}
                photo={president.photoUrl ?? undefined}
                party={president.party ?? undefined}
                mandate={mandate ?? undefined}
              />
            </div>
          </section>
        )}

        {officers.length > 0 && (
          <section>
            <div className="mx-auto grid max-w-3xl grid-cols-1 gap-5 md:grid-cols-2">
              {officers.map((member) => (
                <MemberCard
                  key={member.id}
                  variant="officer"
                  initials={member.initials}
                  name={member.name ?? ''}
                  role={member.role ?? ''}
                  photo={member.photoUrl ?? undefined}
                  party={member.party ?? undefined}
                />
              ))}
            </div>
          </section>
        )}
      </Container>
    </>
  );
}
